import { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { downloadMembers, getMembers } from "../../controllers/user";
import { useAuth } from "../../components/auth/AuthProvider";
import { Link, useParams } from "react-router-dom";
import { getEtapas, getOrg } from "../../controllers/org";
import { getRoles, levels } from "../../controllers/roles";
import Loading from "../../components/loading/Loading";
import { renderRoles } from "../../controllers/utils";
import MemberChangeTeamModal from "../../components/equipo/MemberChangeTeamModal";

/**
 * Levels:
 * - 1: nacional
 * - 2: region
 * - 3: diocesis
 * - 4: comunidad
 * - 5: equipo
 */

function Members( { preloadedMembers, comunidadId, etapaId, equipoId }) {
  const params = useParams();
  let level = 1;
  if (params.regionId) {
    level = 2;
  }
  else if (params.diocesisId) {
    level = 3;
  }
  else if (params.comunidadId) {
    level = 4;
  }
  else if (params.teamId) {
    level = 5;
  }
  const [page, setPage] = useState(0);
  const [org, setOrg] = useState();
  const [roles, setRoles] = useState();
  const [etapas, setEtapas] = useState();
  const [members, setMembers] = useState([]);
  const [count, setCount] = useState(0);
  const [region, setRegion] = useState(level === levels.region ? parseInt(params.regionId) : null);
  const [diocesis, setDiocesis] = useState(level === levels.diocesis ? parseInt(params.diocesisId) : null);
  const [comunidad, setComunidad] = useState(level === levels.comunidad ? parseInt(params.comunidadId) : null);
  const [equipo, setEquipo] = useState(level === levels.equipo ? parseInt(params.teamId) : null);
  const [etapa, setEtapa] = useState();
  const [role, setRole] = useState();
  const [q, setQ] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { token, onLogout } = useAuth();
  const [showChangeTeamModalMembershipId, setShowChangeTeamModalMembershipId] = useState(0);

  useEffect(() => {
    loadMembers();
    loadOrg();
    loadRoles();
    loadEtapas();
  }, []);
  useEffect(() => {
    if (!org) {
      return;
    }
    switch (level) {
      case levels.comunidad:
        const dId = org.comunidades.filter(c => c.comunidad_id === parseInt(params.comunidadId))[0].diocesis_id;
        const rId = org.diocesis.filter(d => d.diocesis_id === dId)[0]?.region_id;
        setRegion(rId);
        setDiocesis(dId);
        setComunidad(parseInt(params.comunidadId));
        break;

      case levels.diocesis:
        setRegion(org.diocesis.filter(d => d.diocesis_id === parseInt(params.diocesisId))[0]?.region_id);
        setDiocesis(parseInt(params.diocesisId));
        break;
    }
  }, [org]);
  useEffect(() => {
    if (q) {
      loadMembers();
    }
  }, [q]);
  useEffect(() => {
    if (!params.diocesisId) {
      setDiocesis();
    }
  }, [region]);
  useEffect(() => {
    setComunidad();
  }, [diocesis]);
  useEffect(() => {
    if (preloadedMembers) {
      setMembers(preloadedMembers);
      setCount(preloadedMembers.length);
    }
  }, [preloadedMembers])

  async function loadMembers () {
    if (preloadedMembers) {
      setMembers(preloadedMembers);
      setCount(preloadedMembers.length);
      return;
    }
    try {
      const d = await getMembers(token, {
        region,
        diocesis,
        comunidad,
        role,
        etapa,
        page: page,
        pageSize: 100
      });
      setMembers(d.rows);
      setCount(d.count);
    }
    catch (e) {
      if (e.status === 401 || e.status === 403) {
        onLogout();
      }
    }
  }
  async function loadOrg(){
    let o = await getOrg();
    setOrg(o);
  }

  async function loadRoles(){
    let r = await getRoles();
    setRoles(r);
  }
  async function loadEtapas(){
    let e = await getEtapas(1);
    let e2 = await getEtapas(2);
    e.push(...e2);
    setEtapas(e);
  }

  async function download() {
    if (isDownloading) {
      return;
    }
    try {
      setIsDownloading(true);
      const d = await downloadMembers(token, {
        region,
        diocesis,
        comunidad,
        role,
        etapa
      });
      setIsDownloading(false);
    }
    catch (e) {
      setIsDownloading(false);
      if (e.status === 401 || e.status === 403) {
        onLogout();
      }
    }
  }

  function showChangeTeamModal(membership_id) {
    console.log('membership_id: ' + membership_id);
    setShowChangeTeamModalMembershipId(membership_id);
  }
  function hideModal() {
    setShowChangeTeamModalMembershipId(0);
  }

  function renderMembers() {
    return members.map((m, i) => <tr key={`member-${m.user_id}-${i}`}>
      <td><Link to={`/app/members/${m.user_id}`}>{m.user.email}</Link></td>
      <td>{m.user.profile.first_name_1}</td>
      <td>{m.user.profile.first_name_2}</td>
      <td>{m.user.profile.last_name}</td>
      {!preloadedMembers && <>
      <td>{m.region.label}</td>
      <td>{m.diocesis.label}</td>
      <td>{m.comunidad.label}</td>
      <td>{renderRoles(m.membership_roles)}</td>
      </>}
      { m.order && <td>Pagado</td>}
      { !m.order && <td><span className="text-danger">No Pagado</span></td>}
      {!!preloadedMembers && level === 5 && <>
        <td><Button variant="secondary" onClick={ev => showChangeTeamModal(m.membership_id)}>Cambiar de equipo</Button></td>
      </>}
    </tr>);
  }

  function renderDiocesisOptions() {
    if (!region) {
      return [
        <option value={null} key={`filter-diocesis-null`}>-- Selecciona una región --</option>
      ]
    }
    let d = org.diocesis.filter(d => d.region_id === region);
    d.unshift({ value: null, label: '-- Selecciona una diócesis -- '});
    return d.map(d => <option value={d.diocesis_id} key={`filter-diocesis-${d.diocesis_id}`}>{d.label}</option> );
  }

  function renderComunidadOptions() {
    if (!region) {
      return [
        <option value={null} key={`filter-comunidad-null-1`}>-- Selecciona una región --</option>
      ];
    }
    if (!diocesis) {
      return [
        <option value={null} key={`filter-comunidad-null-2`}>-- Selecciona una diócesis --</option>
      ];
    }
    let c = org.comunidades.filter(c => c.diocesis_id === diocesis);
    c.unshift({ value: null, label: '-- Selecciona una comunidad -- '});
    return c.map(c => <option value={c.comunidad_id} key={`filter-comunidad-${c.comunidad_id}`}>{c.label}</option> );
  }

  function onSubmit(e) {
    e.preventDefault();
    let newQ = ``;
    function addAmpersand() {
      if (newQ) {
        newQ += '&';
      }
    }
    if (region) {
      newQ += `region=${region}`;
    }
    if (diocesis) {
      addAmpersand();
      newQ += `diocesis=${diocesis}`;
    }
    if (comunidad) {
      addAmpersand();
      newQ += `comunidad=${comunidad}`;
    }
    if (role) {
      addAmpersand();
      newQ += `role=${role}`;
    }
    if (etapa) {
      addAmpersand();
      newQ += `etapa=${etapa}`;
    }
    console.log(`q: ${newQ}`);
    setQ(newQ);
  }

  if (!org || !members || !etapas || !roles || isLoading) {
    return <Loading text="Cargando"></Loading>
  }

  return <Container>
    <h1>Miembros</h1>
    {
    !preloadedMembers &&
    <>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Filtros</Accordion.Header>
          <Accordion.Body>
            <Form onSubmit={onSubmit}>
              <Row>
                {level < levels.region && <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Región</Form.Label>
                    <Form.Select name='region' onChange={e => setRegion(parseInt(e.target.value))}>
                      <option value={null}>-- Selecciona una región --</option>
                      { org.regiones.map(r => <option value={r.region_id} key={`filter-region-${r.region_id}`}>{r.label}</option>) }
                    </Form.Select>
                  </Form.Group>
                </Col>
                }
                {level < levels.diocesis && <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Diócesis</Form.Label>
                    <Form.Select name='diocesis' onChange={e => setDiocesis(parseInt(e.target.value))}>
                      { renderDiocesisOptions() }
                    </Form.Select>
                  </Form.Group>
                </Col>
                }
                {level < levels.comunidad  && <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Comunidad</Form.Label>
                    <Form.Select name='comunidad' onChange={e => setComunidad(parseInt(e.target.value))}>
                      { renderComunidadOptions() }
                    </Form.Select>
                  </Form.Group>
                </Col>
                }
              </Row>
              <Row>
              <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Apostolado</Form.Label>
                    <Form.Select name='apostolado' onChange={e => setRole(parseInt(e.target.value))}>
                      <option value={null}>-- Selecciona un apostolado --</option>
                      { roles.map(r => <option value={r.role_id} key={`filter-role-${r.role_id}`}>{r.label}</option>) }
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nivel</Form.Label>
                    <Form.Select name='etapa' onChange={e => setEtapa(parseInt(e.target.value))}>
                      <option value={null}>-- Selecciona un nivel --</option>
                      { etapas.map(e => <option value={e.etapa_id} key={`etapa-${e.etapa_id}`}>{e.title + (e.type === 1 ? ' - Matrimonios' : ' - MRF')}</option>) }
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Button type="submit" variant="primary">Filtrar</Button>
                </Col>
              </Row>
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Row>
        <Col className="mt-3" style={{textAlign: 'right'}}>
          <Button onClick={download}>{isDownloading ? 'Descargando...' : 'Descargar'}</Button>
        </Col>
      </Row>
    </>
    }

    <Row>
      <Col className="table-wrapper">
        <Table striped hover className="mt-5">
          <thead>
            <tr>
              <td>Email</td>
              <td>Nombre 1</td>
              <td>Nombre 2</td>
              <td>Apellido</td>
              {!preloadedMembers && <>
              <td>Región</td>
              <td>Diócesis</td>
              <td>Comunidad</td>
              <td>Apostolado</td>
              </>}
              <td>Pagado</td>
              {!!preloadedMembers && level === 5 && <>
                <td>Administrar</td>
              </>}
            </tr>
          </thead>
          <tbody>
            {renderMembers()}
          </tbody>
        </Table>
      </Col>  
    </Row>
    {!!showChangeTeamModalMembershipId && 
      <MemberChangeTeamModal
        show={!!showChangeTeamModalMembershipId} 
        membershipId={showChangeTeamModalMembershipId}
        comunidadId={comunidadId}
        etapaId={etapaId}
        equipoId={equipoId}
        handleClose={hideModal}
        />
    }
  </Container>;
}

export default Members;